import React, { useEffect, useRef } from "react";
import "../../styles/animatica.css";

const PILLARS = ["Animation", "VFX", "Gaming", "Filmmaking", "AR/VR/XR"];

const AnimaticaFuture = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className="an-section py-5"
    >
      <div className="an-glow an-glow-left" />
      <div className="container position-relative">
        <div className="row align-items-center justify-content-between">
          <div className="col-md-12 text-center">
            <span className="an-reveal an-reveal-d1 an-eyebrow justify-content-center w-100">
              HKI Animatica
            </span>
            <h2 className="an-reveal an-reveal-d2 fs_35 ff_s fw-bold an-title-gradient d-inline-block">
              Unleash the Future of AVGC-XR and<br></br> Content Production with
              us
            </h2>
            <p
              className="an-reveal an-reveal-d3 fs_16 ff_n text_justify mb-0 mt-3"
              style={{ color: "rgba(248, 250, 252, 0.68)" }}
            >
              <strong style={{ color: "#ef4444" }}>ICASA</strong> stands
              for&nbsp;
              <strong style={{ color: "#ef4444" }}>
                Animation, Media Innovation, AVGC-XR, and Creative Arts,
              </strong>
              &nbsp; embodying HKI Media’s mission to revolutionize the{" "}
              <strong style={{ color: "#ef4444" }}>
                &nbsp; media and entertainment landscape.
              </strong>
              &nbsp; As a premier training and skilling brand,{" "}
              <strong style={{ color: "#ef4444" }}> Animatica </strong>
              empowers students with world-class expertise in{" "}
              <strong style={{ color: "#ef4444" }}>
                {" "}
                animation, VFX, gaming, and filmmaking.{" "}
              </strong>{" "}
              Through its visionary{" "}
              <strong style={{ color: "#ef4444" }}>
                {" "}
                GigMedia App,{" "}
              </strong>{" "}
              another&nbsp;
              <strong style={{ color: "#ef4444" }}>HKI Media vertical,</strong>
              &nbsp; Animatica ensures forward market linkages by connecting its
              trained talent to work opportunities. This app leverages their
              skills, alma mater, and past work ratings, creating a seamless
              pathway for career growth in the AVGC-XR and creative industries.
              Animatica is where artistry meets opportunity!
            </p>
            <div className="an-reveal an-reveal-d4 an-chip-row justify-content-center mt-4">
              {PILLARS.map((pillar) => (
                <span key={pillar} className="an-chip">
                  {pillar}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimaticaFuture;
